



































































import { Component, Watch } from "vue-property-decorator";
import WindowVue from "@/app/core/window/WindowVue";
import { Mixins } from "vue-mixin-decorator";
import VueEvent from "@/app/core/decorator/VueEvent";
import { AppServerSettingInput, DefaultServerInfo } from "@/@types/socket";
import LifeCycle from "@/app/core/decorator/LifeCycle";
import SocketFacade from "@/app/core/api/app-server/SocketFacade";
import BaseInput from "@/app/core/component/BaseInput.vue";
import CtrlButton from "@/app/core/component/CtrlButton.vue";

@Component({
  components: {
    CtrlButton,
    BaseInput
  }
})
export default class AppServerSettingWindow extends Mixins<
  WindowVue<never, AppServerSettingInput>
>(WindowVue) {
  private url: string = "";
  private readonly originalUrlList: DefaultServerInfo[] =
    SocketFacade.instance.appServerUrlList;
  private testMessage: string = "";
  private testStatus: string = "";
  private testServerTitle: string = "";
  private testServerVersion: string = "";

  @LifeCycle
  public async mounted() {
    await this.init();
    this.url = SocketFacade.instance.appServerUrl;
  }

  @Watch("currentDiceBotSystem")
  private onChangeCurrentDiceBotSystem(system: string) {
    window.console.log(system);
  }

  @VueEvent
  private async test() {
    window.console.log("test");
    this.testStatus = "testing";
    try {
      const info = await SocketFacade.instance.testServer(this.url);
      this.testServerTitle = info.title;
      this.testServerVersion = info.serverVersion;
      this.testStatus = "success";
    } catch (err) {
      switch (err) {
        case "internal-server-error":
          this.testMessage = "サーバ内でエラーが発生しました";
          break;
        case "not-quoridorn":
          this.testMessage = "Quoridornサーバではありません";
          break;
        case "no-such-server":
          this.testMessage = "接続できませんでした";
          break;
        case "un-match-version":
          this.testMessage = "互換性の無いバージョンのサーバです";
          break;
        default:
      }
      this.testStatus = err;
    }
  }

  @VueEvent
  private async commit() {
    await this.finally({
      url: this.url
    });
  }

  @VueEvent
  private async rollback() {
    await this.finally();
  }
}
